export const QUICK_FILTER_VALUE_STORAGE_KEY = 'quick_filter_value-';
